import React, { useEffect } from 'react';
import './Experience.css';
import Aos from 'aos';

const Experience = () => {
  useEffect(() => {
    Aos.init({
      duration: 2000,
    });
  }, []);

  return (
    // <div className="hero-content ">
    <div className="flex justify-around flex-wrap items-center  mb-5">
      <div
        data-aos="zoom-in-up"
        className="experience-cards m-5 w-48 h-[100px] cursor-pointer  text-center"
      >
        <h2 className="mt-5 text-lg text-primary font-extrabold">2.5+ Years</h2>
        <h3 className="text-white">of Experience</h3>
      </div>
      <div
        data-aos="zoom-in-up"
        className="experience-cards m-5 w-48 h-[100px] cursor-pointer text-center"
      >
        <h2 className="mt-5 text-lg text-primary font-extrabold">25+ </h2>
        <h3 className="text-white">Happy Clients</h3>
      </div>
      <div
        data-aos="zoom-in-up"
        className="experience-cards m-5 w-48 h-[100px] cursor-pointer text-center"
      >
        <h2 className="mt-5 text-lg text-primary font-extrabold">40+</h2>
        <h3 className="text-white">Projects</h3>
      </div>
      <div
        data-aos="zoom-in-up"
        className="experience-cards m-5 w-48 h-[100px] cursor-pointer text-center"
      >
        <h2 className="mt-5 text-lg text-primary font-extrabold">From 8</h2>
        <h3 className="text-white">Different Countries</h3>
      </div>
    </div>
    /* </div> */
  );
};

export default Experience;
